module.exports = __webpack_public_path__ + "static/media/Event-02.0a995811.svg";